import React, { Component } from 'react'
import TransomConfigurator from '../TransomConfigurator'
import X46MK2ConfiguratorImage from './X46MK2ConfiguratorImage'
import OverlayImageStack from '../OverlayImageStack'

export default class X46MK2TransomConfiguratorImage extends Component {
  constructor (props) {
    super(props)
    this.state = { overlayUrls: [] }
    this.handleOverlayUrls = this.handleOverlayUrls.bind(this)
  }

  handleOverlayUrls (urls) {
    const current = this.state.overlayUrls
    if (urls.length !== current.length || urls.some((u, i) => u !== current[i])) {
      this.setState({ overlayUrls: urls })
    }
  }

  render () {
    const {
      colorMultiplier,
      name,
      port,
      transomSize,
      transform,
      boat,
      configuration,
      options
    } = this.props

    return (
      <div style={{ position: 'relative' }}>
        <TransomConfigurator
          colorMultiplier={colorMultiplier}
          name={name}
          port={port}
          transomSize={transomSize}
          transform={transform}
        >
          <X46MK2ConfiguratorImage
            boat={boat}
            configuration={configuration}
            options={options}
            onOverlayUrls={this.handleOverlayUrls}
          />
        </TransomConfigurator>
        <OverlayImageStack urls={this.state.overlayUrls} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/X46MK2/X46MK2TransomConfiguratorImage.js